import { useEffect } from 'react';

import { isLogFeatureGateExposureMessage } from '@rovo-extension/feature-gates-adapter';

import { extensionUrl } from '../config/config';
import { manuallyLogExposureSafely } from '../experiment/experimentClient';

/**
 * Logs a chrome-layer experiment's exposure through the live SDK client, when the extension's hidden
 * relay page asks. Mounted in `ExposureRelayRoot`, and in `ExtensionApp` for the legacy right-click
 * exposure until https://hello.atlassian.net/browse/ASIMO-5215. Origin check copied from
 * `useChatBridgeAPI`.
 */
export function useFeatureGateExposureRelay(): void {
	useEffect(() => {
		const handler = (event: MessageEvent): void => {
			if (event.origin !== extensionUrl || event.source !== window.parent) {
				return;
			}
			if (!isLogFeatureGateExposureMessage(event.data)) {
				return;
			}

			const { key } = event.data;
			manuallyLogExposureSafely(key);
		};

		window.addEventListener('message', handler);
		return (): void => window.removeEventListener('message', handler);
	}, []);
}
